import type { TOC } from '@ember/component/template-only';
import truncate from 'ember-cli-string-helpers/helpers/truncate';
import EmberTooltip from 'ember-tooltips/components/ember-tooltip';
import { lte, not, or } from 'ember-truth-helpers';

interface TruncateWithTooltipSignature {
  Args: {
    value?: string | null;
    length: number;
    side?: 'top' | 'right' | 'bottom' | 'left';
    popperContainer?: string;
    tooltipClass?: string;
    singleLine?: boolean;
  };
  Element: HTMLDivElement;
}

export default <template>
  <div class={{if @singleLine "overflow-hidden text-ellipsis whitespace-nowrap" "break-words break-all"}} ...attributes>
    {{#let (lte @value.length @length) as |isWithinLength|}}
      {{#if isWithinLength}}
        {{@value}}
      {{else}}
        {{truncate @value @length false}}<span class="text-xs">…</span>
      {{/if}}
      {{! Show the tooltip when the value can be hidden: char-truncated (> @length) OR single-line
          mode, where CSS text-ellipsis clips on pixel width even within @length. }}
      {{#if (or @singleLine (not isWithinLength))}}
        <EmberTooltip
          @side={{or @side "right"}}
          @delay={{300}}
          @popperContainer={{if @popperContainer @popperContainer false}}
          @tooltipClass={{if @tooltipClass @tooltipClass "tooltip"}}
        >
          {{! The tooltip always keeps break-words so an unbroken token (email, UUID) wraps inside
              the tooltip's max-width; single-line mode only drops the aggressive break-all. }}
          <div class={{if @singleLine "break-words" "break-words break-all"}}>{{@value}}</div>
        </EmberTooltip>
      {{/if}}
    {{/let}}
  </div>
</template> satisfies TOC<TruncateWithTooltipSignature>;
